// Tipos de sistemas de seguridad
export const SECURITY_SYSTEM_TYPES = {
  'CCTV': 'CCTV',
  'intrusión': 'Intrusión',
  'control_accesos': 'Control de accesos',
} as const;

// Tipos de sistemas PCI (Protección Contra Incendios)
export const PCI_SYSTEM_TYPES = {
  'pci_deteccion_incendios': 'Detección y alarma de incendios',
  'extintores': 'Extintores',
  'bies_hidrantes': 'BIEs / Hidrantes',
  'pci_deteccion_co': 'Detección y alarma de CO',
  'pci_deteccion_gases': 'Detección y alarma de gases',
  'pci_exutorios': 'Evacuación de humos (exutorios)',
  'pci_sobrepresion': 'Evacuación de humos (sobrepresión)',
  'pci_tuberia': 'Tubería húmeda / seca',
  
  'pci_puertas_cortafuegos': 'Puertas cortafuegos',
  'pci_grupo_presion': 'Grupo de presión',
  'pci_extincion_gaseosa': 'Extinción automática por agentes gaseosos',
  'pci_alumbrado_senalizacion': 'Alumbrado de emergencia y señalización',
} as const;

export const ALL_SYSTEM_TYPES = {
  ...SECURITY_SYSTEM_TYPES,
  ...PCI_SYSTEM_TYPES
} as const;

export const getSystemTypeLabel = (tipo: string): string => {
  return ALL_SYSTEM_TYPES[tipo as keyof typeof ALL_SYSTEM_TYPES] || tipo;
};

export const getSystemCategory = (tipo: string): 'seguridad' | 'pci' => {
  if (tipo in SECURITY_SYSTEM_TYPES) {
    return 'seguridad';
  }
  if (tipo in PCI_SYSTEM_TYPES) {
    return 'pci';
  }
  return 'seguridad';
};

export const getSystemTypesByCategory = (categoria: 'seguridad' | 'pci') => {
  return categoria === 'seguridad' ? SECURITY_SYSTEM_TYPES : PCI_SYSTEM_TYPES;
};
